export const SERVER_ERROR = 'innovA/error/#serverError';

